// Copyright (c) 2019-2024 Cigent Technology Inc. All Rights Reserved.
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-display-relative-changes',
    templateUrl: './display-relative-changes.component.html',
    styleUrls: ['./display-relative-changes.component.scss'],
    standalone: false
})
export class DisplayRelativeChangesComponent {
  @Input() amountChanged: number;
  @Input() relativeChange: number;
  @Input() loading: boolean;
  @Input() alignItems: string = 'center';
  @Input() useThemeColors: boolean = false;
  protected readonly Math = Math;
  themeCssClass = {
    display: 'flex',
    height: '17px',
    width: '150px',
    margin: '3px auto 0 auto',
  };
}
